import { render, staticRenderFns } from "./OrderShipmentData.vue?vue&type=template&id=569f72ec&scoped=true&"
import script from "./OrderShipmentData.vue?vue&type=script&lang=js&"
export * from "./OrderShipmentData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569f72ec",
  null
  
)

export default component.exports